
var convert = require('./convert');
var parse = require('./parse');

/**
 * Expose `convert`.
 */

exports.convert = convert;

/**
 * Expose `parse`.
 */

exports.parse = parse;


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-color-function/lib/index.js
// module id = vZkO
// module chunks = 63